var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"id":"Camera"}},[_c('f7-navbar',{attrs:{"title":"Camera","back-link":"Back"}}),_c('f7-block'),_c('div',{staticClass:"max960"},[_c('f7-block-title',[_vm._v("nofin here yet")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }